import config from '@/config.js'

/**
 * Function to return the full avatar url or the placeholder if it doesn't exists
 * @param  {String} avatar
 * @return {String}
 */
export const getFullAvatarURL = (avatar?: string | null): string => {
  if (!avatar || !avatar.length) {
    return ''
  }

  const prefix = config.get('imgPrefix')

  if (prefix === '') {
    avatar = avatar.replace(`//${config.get('bucket')}/`, '')
  }

  return `https://${config.get('imageService')}/72x72/${prefix}${avatar}`
}
